
const digest = 'cc090a7409e12cd1c9bae936dbc531b8811165527178030738a6a789799e8961';
const classes = {"tabControlWrapper":"_tabControlWrapper_tgdpw_1","primaryControls":"_primaryControls_tgdpw_7","tabButton":"_tabButton_tgdpw_16","tabButtonActive":"_tabButtonActive_tgdpw_26","tab":"_tab_tgdpw_1","textTab":"_textTab_tgdpw_38","textTabWithCanvas":"_textTabWithCanvas_tgdpw_43","controls":"_controls_tgdpw_47","sigCanvas":"_sigCanvas_tgdpw_52","uploadPreview":"_uploadPreview_tgdpw_56","signature":"_signature_tgdpw_60","text":"_text_tgdpw_38","image":"_image_tgdpw_70"};
const css = `._tabControlWrapper_tgdpw_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  width: 100%;
}
._tabControlWrapper_tgdpw_1 ._primaryControls_tgdpw_7 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: -1px;
  z-index: 1;
  justify-content: center;
}
._tabControlWrapper_tgdpw_1 ._tabButton_tgdpw_16 {
  font-size: 16px;
  color: #3e3f42;
  background-color: #f2f4f7;
  border: 1px solid #eaedf3;
  padding: 16px 23px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
}
._tabControlWrapper_tgdpw_1 ._tabButtonActive_tgdpw_26 {
  background-color: #ffffff;
  border-bottom-color: #ffffff;
  color: #619612;
  font-weight: 500;
}

._tab_tgdpw_1 {
  width: 100%;
  border: 1px solid #eaedf3;
}

._textTab_tgdpw_38 {
  text-align: center;
  padding: 40px 0 20px;
}

._textTabWithCanvas_tgdpw_43 {
  padding: 20px;
}

._controls_tgdpw_47 {
  display: flex;
  justify-content: space-between;
}

._sigCanvas_tgdpw_52 {
  border: 1px solid #1665d8;
}

._uploadPreview_tgdpw_56 {
  max-height: 300px;
}

._signature_tgdpw_60 {
  display: flex;
  justify-content: center;
}
._signature_tgdpw_60 ._text_tgdpw_38 {
  text-align: left;
  display: flex;
  align-items: center;
  padding-right: 20px;
}
._signature_tgdpw_60 ._image_tgdpw_70 {
  max-width: 60%;
  padding: 0 40px;
  display: flex;
  align-items: center;
}
._signature_tgdpw_60 ._image_tgdpw_70 img {
  max-width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  